// Continuous CSS marquee. Duplicates content for seamless loop.
export default function Marquee({ items = [], duration = 40, className = "" }) {
  const row = (
    <div className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display font-semibold uppercase tracking-tight text-stroke text-[10vw] leading-none md:text-[7vw]">
            {item}
          </span>
          <span className="mx-6 inline-block h-3 w-3 shrink-0 rotate-45 bg-primary md:mx-12 md:h-4 md:w-4" />
        </span>
      ))}
    </div>
  );
  return (
    <div className={`relative flex w-full overflow-hidden ${className}`}>
      <div className="flex animate-marquee" style={{ "--marquee-duration": `${duration}s` }}>
        {row}
        {row}
      </div>
    </div>
  );
}
